import {
  EPreRaceTableSortingField,
  IPreRaceTableTab
} from "pages/PreRaceScreeningPage/types";
import { SortOrder } from "interfaces/SortOrder";
import { DateRangeISO } from "interfaces/DateRange";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export type TPreRaceScreeningAction =
  | TSetSelectedTabPreRaceTable
  | TSetSelectedPreRaceFacility
  | TSetShowPassedEntriesCheckboxState
  | TSetSortOrder
  | TSetOrderBy
  | TSetSearchValue
  | TSetFacilityBarns
  | TAddAssignCheckedId
  | TRemoveAssignCheckedId
  | TClearAssignCheckedIds
  | TSetShowAssignedToMeOnly
  | TSetUpcomingRaceEntryListRequestKey
  | TSetSelectedDateRange;

type TSetSelectedTabPreRaceTable = ReturnType<
  typeof setSelectedTabPreRaceTable
>;
type TSetSelectedPreRaceFacility = ReturnType<
  typeof setSelectedPreRaceFacility
>;
type TSetShowPassedEntriesCheckboxState = ReturnType<
  typeof setShowPassedEntriesCheckboxState
>;
type TSetSortOrder = ReturnType<typeof setSortOrder>;
type TSetOrderBy = ReturnType<typeof setOrderBy>;
type TSetSearchValue = ReturnType<typeof setSearchValue>;
type TSetFacilityBarns = ReturnType<typeof setFacilityBarns>;
type TAddAssignCheckedId = ReturnType<typeof addAssignCheckedId>;
type TRemoveAssignCheckedId = ReturnType<typeof removeAssignCheckedId>;
type TClearAssignCheckedIds = ReturnType<typeof clearAssignCheckedIds>;
type TSetShowAssignedToMeOnly = ReturnType<typeof setShowAssignedToMeOnly>;
type TSetUpcomingRaceEntryListRequestKey = ReturnType<
  typeof setUpcomingRaceEntryListRequestKey
>;
type TSetSelectedDateRange = ReturnType<typeof setSelectedDateRange>;

const base = "PRE_RACE_SCREENING_PAGE";

export const SET_SELECTED_PRE_RACE_TABLE_TAB = `${base}_SET_SELECTED_PRE_RACE_TABLE_TAB`;
export const SET_SELECTED_PRE_RACE_FACILITY = `${base}_SET_SELECTED_PRE_RACE_FACILITY`;
export const SET_SHOW_PASSED_ENTRIES_CHECKBOX_STATE = `${base}_SET_SHOW_PASSED_ENTRIES_CHECKBOX_STATE`;
export const SET_SORT_ORDER = `${base}_SET_SORT_ORDER`;
export const SET_ORDER_BY = `${base}_SET_ORDER_BY`;
export const SET_SEARCH_VALUE = `${base}_SET_SEARCH_VALUE`;
export const SET_FACILITY_BARNS = `${base}_SET_FACILITY_BARNS`;
export const ADD_ASSIGN_CHECKED_ID = `${base}_ADD_ASSIGN_CHECKED_ID`;
export const REMOVE_ASSIGN_CHECKED_ID = `${base}_REMOVE_ASSIGN_CHECKED_ID`;
export const CLEAR_ASSIGN_CHECKED_IDS = `${base}_CLEAR_ASSIGN_CHECKED_IDS`;
export const SET_SHOW_ASSIGNED_TO_ME_ONLY = `${base}_SET_SHOW_ASSIGNED_TO_ME_ONLY`;
export const SET_UPCOMING_RACE_LIST_REQUEST_KEY = `${base}_SET_UPCOMING_RACE_LIST_REQUEST_KEY`;
export const SET_SELECTED_DATE_RANGE = `${base}_SET_SELECTED_DATE_RANGE`;

export const setSelectedTabPreRaceTable = (selectedTab: IPreRaceTableTab) =>
  ({
    type: SET_SELECTED_PRE_RACE_TABLE_TAB,
    selectedTab
  } as const);

export const setSelectedPreRaceFacility = (
  selectedFacility: racehorse360.IFacility
) =>
  ({
    type: SET_SELECTED_PRE_RACE_FACILITY,
    selectedFacility
  } as const);

export const setShowPassedEntriesCheckboxState = (isChecked: boolean) =>
  ({
    type: SET_SHOW_PASSED_ENTRIES_CHECKBOX_STATE,
    isChecked
  } as const);

export const setSortOrder = (order: SortOrder) =>
  ({
    type: SET_SORT_ORDER,
    order
  } as const);

export const setOrderBy = (orderBy: EPreRaceTableSortingField) =>
  ({
    type: SET_ORDER_BY,
    orderBy
  } as const);

export const setSearchValue = (searchValue: string) =>
  ({
    type: SET_SEARCH_VALUE,
    searchValue
  } as const);

export const setFacilityBarns = (
  barns: Pick<racehorse360.IBarn, "id" | "name">[]
) =>
  ({
    type: SET_FACILITY_BARNS,
    barns
  } as const);

export const addAssignCheckedId = (checkedId: string) =>
  ({
    type: ADD_ASSIGN_CHECKED_ID,
    checkedId
  } as const);

export const removeAssignCheckedId = (unCheckedId: string) =>
  ({
    type: REMOVE_ASSIGN_CHECKED_ID,
    unCheckedId
  } as const);

export const clearAssignCheckedIds = () =>
  ({
    type: CLEAR_ASSIGN_CHECKED_IDS
  } as const);

export const setShowAssignedToMeOnly = (showAssignedToMeOnly: boolean) =>
  ({
    type: SET_SHOW_ASSIGNED_TO_ME_ONLY,
    showAssignedToMeOnly
  } as const);

export const setUpcomingRaceEntryListRequestKey = (key: (string | object)[]) =>
  ({
    type: SET_UPCOMING_RACE_LIST_REQUEST_KEY,
    key
  } as const);

export const setSelectedDateRange = (selectedDateRange: DateRangeISO) =>
  ({
    type: SET_SELECTED_DATE_RANGE,
    selectedDateRange
  } as const);
